import React from 'react';
import { useDeliveryApi } from 'infrastructure/api';
import { DocumentStorageContextData, DocumentStorageContextProvider } from 'framework/documentStorage';
import { ClientPortalTaskAttachment } from '../types';
import { getFileTypeFromName, getFileTypeIcon } from 'domain/shared/artifact/utils';

type Props = {
  projectId: string;
  taskId?: string;
  attachments: (ClientPortalTaskAttachment & { filePreview?: string })[];
  children: React.ReactNode;
};

const ClientPortalDocumentsContext = ({ projectId, taskId, attachments, children }: Props) => {
  const { sendGetRequest } = useDeliveryApi();
  const getDocumentByPaths = async (ids: string[]) =>
    attachments
      .filter(attachment => ids.includes(attachment.id))
      .map(attachment => ({
        ...attachment,
        filePreview: attachment.filePreview || getFileTypeIcon(getFileTypeFromName(attachment.fileName)),
        path: attachment.id,
        metadata: {
          fileName: attachment.fileName,
          entityName: 'ClientTask',
          entityId: taskId || '',
          createdAt: attachment.uploadedAt,
          createdBy: '',
        },
      }));

  const getDocumentToken = async (attachmentId: string) => {
    const response = await sendGetRequest(
      `/projects/${projectId}/client-portal/tasks/${taskId}/attachments/${attachmentId}/download-link`,
    );
    const { url } = await response.json();
    return url;
  };

  const value: Pick<DocumentStorageContextData, 'getDocumentByPaths' | 'getDocumentToken'> = {
    getDocumentByPaths,
    getDocumentToken,
  };

  return (
    <DocumentStorageContextProvider value={value as DocumentStorageContextData}>
      {children}
    </DocumentStorageContextProvider>
  );
};

export default ClientPortalDocumentsContext;
